module.exports = __webpack_public_path__ + "static/managed_service_solutions-eb4ed5176577a82926a6159c6f6a4547.svg";